import { MessageCircle } from "lucide-react";
import { motion } from "framer-motion";
import { useStoreConfig } from "../../features/config/queries";

export function FloatingWhatsAppButton() {
  const { data: config } = useStoreConfig();
  const whatsappNumber = config?.whatsappNumber?.replace(/[^\d]/g, "");

  if (!whatsappNumber) return null;

  return (
    <motion.a
      href={`https://wa.me/${whatsappNumber}`}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat with us on WhatsApp"
      title="Chat with us on WhatsApp"
      whileHover={{ scale: 1.08, y: -2 }}
      whileTap={{ scale: 0.95 }}
      transition={{ duration: 0.25, ease: [0.22, 1, 0.36, 1] }}
      className="fixed bottom-24 right-6 z-40 h-14 w-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lifted hover:bg-[#1ebe5a] transition-colors duration-300"
    >
      <MessageCircle size={26} />
    </motion.a>
  );
}
